import { all } from 'redux-saga/effects'
import { settingsSagas } from './settings/settings.sagas'

export function * rootSaga () {
  yield all([
    settingsSagas(),
  ])
}
